import { Component, Input } from "@angular/core";

@Component({
  selector: "evrideo-tenant-settings-select-ai-model",
  template: `
    <div>need to implement</div>
  `,
})
export class TenantSettingsSelectAiModelComponent {

}
